<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.status" @change="handleTabs">
          <el-radio-button :label="1"
            >已收到({{ table.total_1 }})</el-radio-button
          >
          <el-radio-button :label="2"
            >邀面试({{ table.total_2 }})</el-radio-button
          >
          <el-radio-button :label="3"
            >已通过({{ table.total_3 }})</el-radio-button
          >
          <el-radio-button :label="4"
            >不合适({{ table.total_4 }})</el-radio-button
          >
          <el-radio-button :label="5"
            >已下载({{ table.total_5 }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-form
        ref="elFormDom"
        class="flex"
        inline
        :model="table.params"
        size="small"
      >
        <el-form-item
            label="企业名称"
            prop="company_id"
          >
            <el-select
              v-model="table.params.company_id"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item
          label="面试时间"
          prop="interview_time"
          v-if="table.params.status != 1"
        >
          <el-date-picker
            style="width: 250px"
            v-model="table.params.interview_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="岗位名称" prop="job_id">
          <el-select clearable filterable v-model="table.params.job_id">
            <el-option
              :label="item.title"
              :value="item.id"
              :key="index"
              v-for="(item, index) in jobOption_"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简历名称" prop="name">
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            clearable
            v-model.trim="table.params.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select clearable v-model="table.params.sex">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select
            v-model="table.params.education"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in education_.filter((item) => item.id != -1)"
              :label="item.value"
              :value="item.id"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学校类型" prop="school_type">
          <el-select clearable v-model="table.params.school_type">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in schooltype_"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名称" prop="school_id">
          <el-select
            v-model="table.params.school_id"
            filterable
            remote
            placeholder="请输入关键词"
            reserve-keyword
            :remote-method="getSchoolOptionQuery"
            clearable
          >
            <el-option
              v-for="item in schoolOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄段" prop="age_type">
          <el-select clearable v-model="table.params.age_type">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in ageTypeOptions_"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >查询
          </el-button>
          <el-button icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        showIndex
        title=""
        addText="添加"
        :cellStyle="cellStyle"
        :field="getField()"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:nickname="{ row }">
          <div class="title-box">
            <el-avatar
              :size="32"
              :src="row.avatar ? row.avatar : defaultAvator"
            >
            </el-avatar>
            <div class="title-box-right">
              <div class="title-box-right-1">
                <div style="max-width:100px;overflow: hidden;">
                  {{
                    row.attach_resume && row.attach_resume.name
                      ? row.attach_resume.name
                      : row.nickname
                  }}
                </div>
                <div
                  class="sex"
                  :class="{ isman: row.sex == 1, iswomen: row.sex == 2 }"
                >
                  {{ row.sex == 1 ? "男" : row.sex == 2 ? "女" : "" }}
                </div>
                <el-image
                  style="width: 50px; margin-left: 6px"
                  v-if="row.is_honesty == 1"
                  :src="require('@/assets/img/chengxinbaoPlus.png')"
                ></el-image>
                <el-image
                  style="
                    width: 50px;
                    margin-left: 6px;
                    display: flex;
                    justify-content: center;
                  "
                  v-if="row.is_honesty == 2 && row.is_vip == 1"
                  :src="require('@/assets/img/vip.png')"
                ></el-image>
                <el-image
                  style="
                    width: 50px;
                    margin-left: 6px;
                    display: flex;
                    justify-content: center;
                  "
                  v-if="row.pass_user_auth == 1"
                  :src="require('@/assets/img/mxrz.png')"
                ></el-image>
              </div>
              <div class="title-box-right-2">
                <span>{{ row.age }}岁 |</span>
                <span>{{ row.school }} |</span>
                <span>{{ row.major_str }} </span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:invite_status="{ row }">
          <span>{{
            toStr(
              {
                0: "待接受",
                1: "已接受",
                2: "已拒绝",
              },
              row.invite_status
            )
          }}</span>
        </template>
        <template v-slot:offer_status="{ row }">
          <span v-if="row.job_type == 3 && table.params.status == 3"
            >已通过</span
          >
          <span v-else>{{
            toStr(
              {
                1: "待接受offer",
                2: "已接受offer",
                3: "已放弃offer",
              },
              row.offer_status
            )
          }}</span>
        </template>
        <template v-slot:days="{ row }">
          <span>{{ getDays(row.days) }}</span>
        </template>
        <template v-slot:action="{ row }">
          <!-- is_new 0:新消息 1:老消息 -->
          <div class="btn-row">
            <template
              v-if="
                table.params.status == 1 ||
                table.params.status == 3 ||
                table.params.status == 4 ||
                table.params.status == 5
              "
            >
              <el-button
                style="position: relative"
                size="mini"
                @click="viewJianLi(row)"
                >查看</el-button>
            </template>
            <template v-if="table.params.status == 2">
              <el-button
                style="position: relative"
                size="mini"
                @click="viewJianLi(row)"
                >查看</el-button
              >
            </template>
            <!-- //简历下载类型：1-在线简历；2-附件简历； -->
            <el-button
              v-if="row.resume_down_type == 2"
              size="mini"
              @click="viewPdf(row)"
              >附件简历</el-button
            >
          </div>
        </template>
      </VTable>
    </div>
    <pdf-preview ref="pdfPreviewRef"></pdf-preview>
    <el-drawer
      size="800px"
      show-close
      :withHeader="false"
      @close="getTable"
      append-to-body
      :visible.sync="drawerVisible"
      :title="drawerTitle"
    >
      <jianLi
        ref="jianliRef"
        @refresh="getTable"
        @closeDrawer="() => (drawerVisible = false)"
      ></jianLi>
    </el-drawer>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import PdfPreview from "@/components/PdfPreview.vue";
import jianLi from "@/components/jianLi.vue";
export default {
  name: "resumeManagement",
  mixins: [mixinTable],
  components: {
    VTable,
    PdfPreview,
    jianLi
  },
  data() {
    return {
      drawerVisible: false,
      defaultAvator: require("@/assets/img/default1.png"),
      field1: [
        {
          name: "nickname",
          label: "简历名称",
          showTooltip: true,
          width: "300",
          hidden: false,
        },
        { name: "mobile", label: "联系电话", hidden: false },
        { name: "job_name", label: "投递岗位", hidden: false },
        { name: "company_name", label: "所属企业", hidden: false },
        { name: "send_time", label: "投递时间", hidden: false },
        { name: "days", label: "活跃情况", hidden: false },
        { name: "action", label: "操作", width: "180", hidden: false },
      ],
      field2: [
        {
          name: "nickname",
          label: "简历名称",
          showTooltip: true,
          width: "300",
          hidden: false,
        },
        { name: "mobile", label: "联系电话", hidden: false },
        { name: "job_name", label: "投递岗位", hidden: false },
        { name: "company_name", label: "所属企业", hidden: false },
        { name: "send_time", label: "投递时间", hidden: false },
        { name: "interview_time", label: "面试时间", hidden: false },
        { name: "invite_status", label: "状态", hidden: false },
        { name: "days", label: "活跃情况", hidden: false },
        { name: "action", label: "操作", width: "180", hidden: false },
      ],
      field3: [
        {
          name: "nickname",
          label: "简历名称",
          showTooltip: true,
          width: "300",
          hidden: false,
        },
        { name: "mobile", label: "联系电话", hidden: false },
        { name: "job_name", label: "投递岗位", hidden: false },
        { name: "company_name", label: "所属企业", hidden: false },
        { name: "send_time", label: "投递时间", hidden: false },
        { name: "interview_time", label: "面试时间", hidden: false },
        { name: "update_time", label: "通过时间", hidden: false },
        { name: "offer_status", label: "状态", hidden: false },
        { name: "action", label: "操作", width: "180", hidden: false },
      ],
      field4: [
        {
          name: "nickname",
          label: "简历名称",
          showTooltip: true,
          width: "300",
          hidden: false,
        },
        { name: "mobile", label: "联系电话", hidden: false },
        { name: "job_name", label: "投递岗位", hidden: false },
        { name: "company_name", label: "所属企业", hidden: false },
        { name: "send_time", label: "投递时间", hidden: false },
        { name: "interview_time", label: "面试时间", hidden: false },
        { name: "refuse_time", label: "处理时间", hidden: false },
        { name: "action", label: "操作", width: "180", hidden: false },
      ],
      field5: [
        {
          name: "nickname",
          label: "简历名称",
          showTooltip: true,
          width: "300",
          hidden: false,
        },
        { name: "company_name", label: "所属企业", hidden: false },
        { name: "mobile", label: "联系电话", hidden: false },
        { name: "update_time", label: "下载时间", hidden: false },
        { name: "days", label: "活跃情况", hidden: false },
        { name: "action", label: "操作", width: "180", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          status: 1,
          interview_time: [],
          job_id: [],
          name: "",
          phone: "",
          sex: "",
          education: "",
          school_type: "",
          age_type: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        total_1: "",
        total_2: "",
        total_3: "",
        total_4: "",
        total_5: "",
      },
      drawerVisible: false,
      jobOption_: [],
      areaArr: [],
      education_: [],
      schoolOption: [],
      companyList: [],
      ageTypeOptions_: [
        { label: "20岁以内", value: 1 },
        { label: "20-29岁", value: 2 },
        { label: "30-39岁", value: 3 },
        { label: "40-49岁", value: 4 },
        { label: "50岁及以上", value: 5 },
      ],
      schooltype_: [
        { label: "985", value: 1 },
        { label: "211", value: 2 },
        { label: "双一流", value: 3 },
        { label: "其他", value: 4 },
      ],
      drawerTitle: "",
    };
  },
  created() {
    this.getTable();
    this.getJobList();
    this.getSchoolOption();
    this.getParamsJob();
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    cellStyle({ row }) {
      if (!row.is_read && this.table.params.status == 1) {
        return "font-weight: 600;";
      } else {
        return "";
      }
    },
    getDays(days) {
      if (days === -1) {
        return "未登录";
      } else if (days === 0) {
        return "今日登录";
      } else {
        return `${days < 7 ? days : 7}天前活跃`;
      }
    },
    getField() {
      switch (this.table.params.status) {
        case 1:
          return this.field1;
        case 2:
          return this.field2;
        case 3:
          return this.field3;
        case 4:
          return this.field4;
        case 5:
          return this.field5;
      }
    },
    // 获取省市区
    getArea() {
      this.$http.get("/common/district/all", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.areaArr = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getTable() {
      let _params = {
        ...this.table.params,
        interview_time: this.table.params.interview_time
          ? this.table.params.interview_time.join("|")
          : "",
      };
      this.$http.get("/admin/resume/list", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.total_1 = res.data.total_1;
          this.table.total_2 = res.data.total_2;
          this.table.total_3 = res.data.total_3;
          this.table.total_4 = res.data.total_4;
          this.table.total_5 = res.data.total_5;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      if (this.table.params.status === 1) {
        this.table.params.interview_time = [];
      }
      this.table.data = [];
      this.getTable();
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    viewJianLi(row) {
      this.drawerVisible = true;
      this.drawerTitle = `投递岗位:${row.job_name}>`;
      this.$nextTick(() => {
        let dom = this.$refs.jianliRef;
        dom.toggle(true);
        dom.getUserInfo(row, 0); //这里都是下载过的
        dom = null;
      });
    },
    pass(row) {
      if (row.job_type == 3) {
        this.$confirm(`请确认通过？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              status: 5, //类型  3:邀面试 4:不合适 5:面试通过 6:面试不通过
              id: row.id,
            };
            this.$http.post("/company/resume/operation", params).then((res) => {
              if (res.code == 1) {
                this.$message.success("操作成功");
                this.getTable();
              }
            });
          })
          .catch(() => {});
      } else {
        let dom = this.$refs.sendOfferRef;
        dom.toggle(true);
        dom.getdetails(row);
      }
    },
    reject(row) {
      this.$confirm(`请确认不合适？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            status: 6, //类型  3:邀面试 4:不合适 5:面试通过 6:面试不通过
            id: row.id,
          };
          this.$http.post("/company/resume/operation", params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    viewPdf(row) {
      let dom = this.$refs.pdfPreviewRef;
      if (dom) {
        let obj = row.attach_resume;
        let {path="", name=""} = obj;
        dom.open({
          url: path,
          name: name,
        });
      }
    },
    viewJianLi(row) {
      this.drawerVisible = true;
      this.drawerTitle = `投递岗位:${row.job_name}>`;
      this.$nextTick(() => {
        let dom = this.$refs.jianliRef;
        dom.toggle(true);
        dom.getUserInfo(row, 0); //这里都是下载过的
        dom = null;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  ::v-deep .el-button {
    margin-left: 0px;
  }
}
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.title-box {
  display: flex;
  align-items: center;
  .el-avatar {
    flex-shrink: 0;
  }
  .title-box-right {
    flex: 1;
    margin-left: 8px;
    min-width: 0;
  }
}
.title-box-right-2 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.title-box-right-1 {
  display: flex;
  align-items: center;
  .sex {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
}
.isman {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #25a5e2;
}
.iswomen {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ff8ba9;
}
.bage-box {
  height: 8px;
  width: 8px;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #f56c6c;
  border-radius: 50%;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #30c3b1;
  font-size: 12px;
  margin: 0 0 0 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>